import script from "./TeacherCourses.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherCourses.vue?vue&type=script&setup=true&lang=js"

import "@/assets/common.css?vue&type=style&index=0&lang=css&external"
import "./TeacherCourses.vue?vue&type=style&index=1&id=2cb31aea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb31aea"]])

export default __exports__